/* =========================================================
    1. STICKY HEADER & MAIN MEGA MENU CONTROLLER
========================================================= */
const initHeaderNavigation = () => {
  const header = document.querySelector(".login-header");
  const megaMenu = document.querySelector(".login-mega-menu");
  const menuItems = document.querySelectorAll(".login-menu__item[data-mega]");
  const panels = document.querySelectorAll(".mega-panel");

  if (!header) return;

  // Sticky Scroll Handling
  window.addEventListener("scroll", () => {
    header.classList.toggle("is-sticky", window.scrollY > 80);
  });

  if (!megaMenu) return;

  let hideTimer;

  // Function: Panel open hone par us ke pehle Category/Tab ko auto-select karna
  const activateFirstTabInPanel = (panel) => {
    if (!panel) return;

    const firstCategory = panel.querySelector(".mega-category-list li");
    if (!firstCategory) return;

    const activeTab = firstCategory.dataset.tab;

    // Reset & Activate Category
    panel.querySelectorAll(".mega-category-list li").forEach((li) => {
      li.classList.toggle("active", li === firstCategory);
    });

    // Reset & Activate Products Panel
    panel.querySelectorAll(".mega-products-panel").forEach((prod) => {
      prod.classList.toggle("active", prod.dataset.tab === activeTab);
    });

    // Reset & Activate Banners Panel
    panel.querySelectorAll(".mega-banner-panel").forEach((banner) => {
      const isActive = banner.dataset.tab === activeTab;
      banner.classList.toggle("active", isActive);
    });
  };

  // Header Nav Links Hover Event
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      clearTimeout(hideTimer);
      megaMenu.classList.add("active");

      const target = item.dataset.mega;

      panels.forEach((panel) => {
        const isTarget = panel.dataset.mega === target;
        panel.classList.toggle("active", isTarget);

        if (isTarget) {
          activateFirstTabInPanel(panel);
        }
      });
    });
  });

  megaMenu.addEventListener("mouseenter", () => clearTimeout(hideTimer));

  header.addEventListener("mouseleave", () => {
    hideTimer = setTimeout(() => {
      megaMenu.classList.remove("active");
    }, 150);
  });
};

/* =========================================================
    2. CATEGORY TABS HOVER & SWIPER INITIALIZATION
========================================================= */
const initMegaMenuTabsAndSliders = () => {
  const megaMenu = document.querySelector(".login-mega-menu");
  if (!megaMenu) return;

  // Category List Items Hover Event (Scoped to current panel)
  megaMenu.querySelectorAll(".mega-category-list li").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const currentPanel = item.closest(".mega-panel");
      if (!currentPanel) return;

      const tab = item.dataset.tab;

      // Update Category List
      currentPanel.querySelectorAll(".mega-category-list li").forEach((i) => {
        i.classList.toggle("active", i === item);
      });

      // Update Product Panels
      currentPanel.querySelectorAll(".mega-products-panel").forEach((prod) => {
        prod.classList.toggle("active", prod.dataset.tab === tab);
      });

      // Update Banner Panels
      currentPanel.querySelectorAll(".mega-banner-panel").forEach((banner) => {
        const isActive = banner.dataset.tab === tab;
        banner.classList.toggle("active", isActive);
      });
    });
  });
};

/* =========================================================
    3. MOBILE MENU & ACCORDIONS (EVENT BUBBLING FIX)
========================================================= */
const initMobileNavigation = () => {
  const burger = document.querySelector(".login-header__burger");
  const mobileMenu = document.querySelector(".login-mobile-menu");
  const overlay = document.querySelector(".login-mobile-menu__overlay");

  if (burger && mobileMenu) {
    burger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const isActive = mobileMenu.classList.contains("active");
      if (isActive) {
        mobileMenu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("no-scroll");
      } else {
        mobileMenu.classList.add("active");
        burger.classList.add("active");
        document.body.classList.add("no-scroll");
      }
    });

    overlay?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobileMenu.classList.remove("active");
      burger.classList.remove("active");
      document.body.classList.remove("no-scroll");
    });
  }

  // Close Button Handler
  document.addEventListener("click", (e) => {
    if (e.target.closest(".login-mobile-menu__close")) {
      e.preventDefault();
      if (mobileMenu) {
        mobileMenu.classList.remove("active");
        burger?.classList.remove("active");
        document.body.classList.remove("no-scroll");
      }
    }
  });

  // Main Category Accordion
  const mainAccordionBtn = document.querySelector(".mobile-main-accordion-btn");
  if (mainAccordionBtn) {
    mainAccordionBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const mainAccordion = this.closest(".mobile-main-accordion");
      if (mainAccordion) {
        mainAccordion.classList.toggle("active");
      }
    });
  }

  // Inner Accordion Items
  const categoryItems = document.querySelectorAll(".mobile-accordion-item");
  categoryItems.forEach((item) => {
    const btn = item.querySelector(".mobile-accordion-btn");
    if (!btn) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isCurrentActive = item.classList.contains("active");

      categoryItems.forEach((other) => {
        if (other !== item) {
          other.classList.remove("active");
        }
      });

      item.classList.toggle("active", !isCurrentActive);
    });
  });
};

/* =========================================================
   4. PAGE BANNER BRIGHTNESS DETECTION (ROBUST RESPONSIVE FIX)
========================================================= */
const initBannerBrightnessCheck = () => {
  const header = document.querySelector(".login-header");
  if (!header) return;

  const bannerSelector = [
    ".collection-banner-img",
    ".landing-banner-image",
    ".login-contact-hero img",
    ".login-privacy-policy__hero",
    ".login-blog-page__hero img",
    ".bulk-hero img",
    ".login-warranty-claim__hero img",
    ".warranty-hero img",
    ".login-about__hero img",
    ".login-policy__hero img",
    ".login-shipping__hero img",
    ".lsb-hero-banner img",
    ".login-store-locator-hero img",
    ".hero-banner-wrapper img",
    ".ds-hero-banner-wrapper img",
    ".hero-banner-wrapper video",
    ".hero-video-clip-container video",
    ".speakers-banner-wrapper img"
  ].join(", ");

  const checkHeaderPosition = () => {
    const allBanners = document.querySelectorAll(bannerSelector);
    let banner = null;
    
    for (let i = 0; i < allBanners.length; i++) {
      const el = allBanners[i];
      if (el && (el.offsetWidth > 0 || el.offsetHeight > 0 || window.getComputedStyle(el).display !== 'none')) {
        banner = el;
        break;
      }
    }

    if (!banner) return;

    // Agar 11.11 sale page ya dark themed hero video/image hai toh direct dark class enforce kar dein
    const isSalePage = window.location.pathname.includes('11-11-sale') || banner.closest('.sale-1111-wrapper');
    if (isSalePage) {
      header.classList.add("login-header--banner-dark");
      header.classList.remove("login-header--inner");
      return;
    }

    if (banner.tagName === "IMG" && !banner.crossOrigin) {
      banner.crossOrigin = "anonymous";
    }

    const isVideo = banner.tagName === "VIDEO";
    const mediaWidth = isVideo ? banner.videoWidth : banner.naturalWidth;
    const mediaHeight = isVideo ? banner.videoHeight : banner.naturalHeight;

    if (!mediaWidth || !mediaHeight) {
      // Fallback agar dimensions load nahi hue
      return;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const headerRect = header.getBoundingClientRect();
    const bannerRect = banner.getBoundingClientRect();

    const relativeX = headerRect.left - bannerRect.left;
    const widthRatio = mediaWidth / bannerRect.width;

    const sampleX = Math.max(0, relativeX * widthRatio);
    const sampleWidth = Math.max(10, headerRect.width * widthRatio);

    canvas.width = sampleWidth;
    canvas.height = Math.min(120, mediaHeight);

    try {
      ctx.drawImage(
        banner, 
        sampleX, 0, sampleWidth, mediaHeight, 
        0, 0, canvas.width, canvas.height
      );

      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let totalBrightness = 0;
      let pixelCount = 0;

      for (let i = 0; i < data.length; i += 4) {
        totalBrightness += data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
        pixelCount++;
      }

      const averageBrightness = totalBrightness / (pixelCount || 1);
      const isDarkBanner = averageBrightness < 140;

      header.classList.toggle("login-header--banner-dark", isDarkBanner);
      header.classList.toggle("login-header--inner", !isDarkBanner);
    } catch (error) {
      console.warn("CORS/Canvas restriction caught, defaulting based on page type:", error);
      // Fallback: Agar canvas error de toh dark background assume kar lein agar dark theme page ho
      header.classList.add("login-header--banner-dark");
      header.classList.remove("login-header--inner");
    }
  };

  window.addEventListener("scroll", checkHeaderPosition);
  window.addEventListener("resize", checkHeaderPosition);

  setTimeout(checkHeaderPosition, 400);

  const banners = document.querySelectorAll(bannerSelector);
  banners.forEach(banner => {
    if (banner.tagName === "VIDEO") {
      if (banner.readyState >= 1) {
        checkHeaderPosition();
      } else {
        banner.addEventListener("loadedmetadata", checkHeaderPosition, { once: true });
      }
    } else {
      if (banner.complete && banner.naturalWidth > 0) {
        checkHeaderPosition();
      } else {
        banner.addEventListener("load", checkHeaderPosition, { once: true });
      }
    }
  });
};

/* =========================================================
   INITIALIZE ALL FUNCTIONS ON DOM LOAD
========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  initHeaderNavigation();
  initMegaMenuTabsAndSliders();
  initMobileNavigation();
  initBannerBrightnessCheck();
});